@if (ready) {
<div class="smartFormLogic-card">
  @if (editable && !isProductionMode) {
  <div style="margin-bottom: 10px; width: 100%; position: relative;">
    <i class="editButton edit icon" (click)="triggerEdit()"></i>
  </div>
  }
  <div class="flex">
    <h4 class="noMargin">IF</h4>
    <div class="subject">
      {{
        rootCondition.questionId +
          " - " +
          getQuestionById(rootCondition.questionId)
      }}
    </div>
    <h4 class="noMargin operator">{{ rootCondition.operator + ": " }}</h4>
    <div class="requirement">"{{ rootCondition.value }}"</div>
  </div>
  <!-- TODO: make this dynamically work with any amount of nesting -->
  @for (additionalCondition of rootCondition.andChildren; track
  additionalCondition) {
  <div>
    <h4 class="noMargin">AND</h4>
    <div class="flex">
      <h4 class="noMargin">IF</h4>
      <div class="subject">
        {{
          additionalCondition.questionId +
            " - " +
            getQuestionById(additionalCondition.questionId)
        }}
      </div>
      <h4 class="operator noMargin">
        {{ additionalCondition.operator + ": " }}
      </h4>
      <div class="requirement">"{{ additionalCondition.value }}"</div>
    </div>
  </div>
  }
  <br />
  <hr />
  <div>
    @if (showActions.length > 0) {
    <div class="flex" style="margin-top: 5px;">
      <h4 class="noMargin">THEN</h4>
      <div class="flex" style="gap: 0.3rem;">
        <div class="flex-v" style="gap: 0px;">
          @if (categoryShowActions.length > 0) {
          <div>
            {{
              categoryShowActions.length +
                " categories " +
                (showContainsCategory ? "(including this) " : "")
            }}
          </div>
          } @if (subCategoryShowActions.length > 0) {
          <div>
            {{
              subCategoryShowActions.length +
                " subcategories " +
                (showContainsSubCategory ? "(including this) " : "")
            }}
          </div>
          } @if (questionShowActions.length > 0) {
          <div>
            {{
              questionShowActions.length +
                " questions " +
                (showContainsQuestion ? "(including this) " : "")
            }}
          </div>
          }
        </div>
        {{ " " }} - will be made visible
      </div>
    </div>
    } @if (mandatoryActions.length > 0 && showActions.length > 0) {
    <hr
      style="margin-top: 0.5rem; margin-bottom: 0.5rem; border-color: #90909030;"
    />
    } @if (mandatoryActions.length > 0) {
    <div class="flex" style="margin-top: 5px;">
      <h4 class="noMargin">
        {{ mandatoryActions.length > 0 ? "AND " : "THEN: " }}
      </h4>
      <div class="flex" style="gap: 0.3rem;">
        <div class="flex-v" style="gap: 0px;">
          @if (categoryMandatoryActions.length > 0) {
          <div>
            {{
              categoryMandatoryActions.length +
                " categories " +
                (mandatoryContainsCategory ? "(including this) " : "")
            }}
          </div>
          } @if (subCategoryMandatoryActions.length > 0) {
          <div>
            {{
              subCategoryMandatoryActions.length +
                " subcategories " +
                (mandatoryContainsSubCategory ? "(including this) " : "")
            }}
          </div>
          } @if (questionMandatoryActions.length > 0) {
          <div>
            {{
              questionMandatoryActions.length +
                " questions " +
                (mandatoryContainsQuestion ? "(including this) " : "")
            }}
          </div>
          }
        </div>
        {{ " " }} - will made mandatory
      </div>
    </div>
    }
  </div>
</div>
}
